import { LandscapeTray } from '../../../domain/landscape-tray';
import {
  CreateLandscapePageItemRequestApiModel,
  UpdateLandscapePageItemRequestApiModel,
  LandscapePageItemApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  displayServiceTypeIconMapperDomainToApi,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import {
  commonMapper,
  dthStatusMapper,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { LandscapeTrayFormViewModel } from './landscape-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  displayServiceTypeIconMapper,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

export const mapLandscapeTrayDomainModelToApiModel = (
  item: LandscapeTray,
  pageVersionId?: string,
  tenantId?: string
): CreateLandscapePageItemRequestApiModel & UpdateLandscapePageItemRequestApiModel => {
  const { contentGroup, layout, subType, trayCategory } = item;

  const commonProperties = mapperPipe(
    item,
    nameLocalizedMapperDomainToApi,
    targetingMapperDomainToApi,
    displayServiceTypeIconMapperDomainToApi,
    scheduledDateMapperDomainToApi
  );

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    contentGroupId: contentGroup.id,
    tenantId,
    layout,
    subType,
    trayCategory,
  }));
};

export const mapLandscapeTrayApiModelToDomainModel = (landscapePageItem: LandscapePageItemApiModel): LandscapeTray => {
  const { contentGroup, layout, subType, trayCategory } = landscapePageItem;
  const { id, title, updatedAt, referringPageNames } = contentGroup;

  return remainderMapper(
    mapperPipe(
      landscapePageItem,
      commonMapper,
      nameLocalizedMapperApiToDomain,
      targetingMapperApiToDomain,
      scheduledDateMapperApiToDomain,
      displayServiceTypeIconMapperDomainToApi,
      dthStatusMapper
    ),
    () => ({
      type: 'LandscapeTray',
      subType,
      contentGroup: {
        id,
        name: title,
        modified: updatedAt,
        referringPages: referringPageNames || [],
      },
      layout,
      trayCategory,
    })
  );
};

export const mapLandscapeTrayDomainModelToViewModel = (value: LandscapeTray): LandscapeTrayFormViewModel => {
  const { contentGroup, layout, subType, trayCategory } = value;

  const commonProperties = mapperPipe(
    value,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.LandscapeTray,
    subType,
    contentGroup,
    layout,
    trayCategory,
  }));
};

export const mapLandscapeTrayViewModelToDomainModel = (vm: LandscapeTrayFormViewModel): LandscapeTray => {
  const { contentGroup, layout, subType, trayCategory } = vm;

  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'LandscapeTray',
    subType,
    contentGroup,
    layout,
    trayCategory,
  }));
};
